import { render, staticRenderFns } from "./ListagemCotacao.vue?vue&type=template&id=04702ca0"
import script from "./ListagemCotacao.vue?vue&type=script&lang=js"
export * from "./ListagemCotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports